import React from 'react';
import { Navigate } from 'react-router';
import Base from '../../Base';
import SelectAsync from 'react-select/async';
import DatePicker from 'react-datepicker2';
import NumberFormat from 'react-number-format';

export default class Curriculum extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
            caller: props.Caller,
            data: null,
            loading: true,
            pic: '',
        }
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.addKeyDown();
        this.httpPost("api/v1/curriculum/get", {
            id: this.state.id,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.state.data = data;
                    this.setState({
                        loading: false
                    });
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    setProfilePic(_file) {
        this.getBase64(_file).then(file => {
            this.state.pic = file;
        });
    }
    save(e) {
        if (!this.isNull(e)) e.preventDefault();
        if (this.isBlank(this.state.data.record.code)) this.state.data.record.code = 0;
        if (this.isBlank(this.state.data.record.duration)) this.state.data.record.duration = 0;
        if (this.isBlank(this.state.data.record.repeat)) this.state.data.record.repeat = 0;

        this.httpPost("api/v1/curriculum/save", {
            id: this.getCurrentFormId(),
            companyId: this.state.data.global.company.id,
            title: this.state.data.record.title,
            code: this.state.data.record.code,
            description: this.state.data.record.description,
            isActive: this.state.data.record.isActive,
            curriculumLevelId: this.state.data.record.curriculumLevelId,
            curriculumTypeId: this.state.data.record.curriculumTypeId,
            personId: this.state.data.record.personId,
            startDate: this.convertMomentToDb(this.state.data.record.startDate),
            duration: this.state.data.record.duration,
            repeat: this.state.data.record.repeat,
            base64BodyImage: this.state.pic,
            items: this.state.data.record.items
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                    this.state.caller.refreshData();
                    this.closeMe();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    getBlankRow() {
        return {
            id: this.uuidv4(),
            movementId: null,
            count: 1,
            count2: 1,
            index: this.state.data.record.items.length
        };
    }
    addNewRow() {
        var v = this.getBlankRow();
        this.state.data.record.items.push(v);
        this.setState({ data: this.state.data });
    }
    removeRow(id) {
        var t = [];
        this.state.data.record.items.forEach(i => {
            if (i.id != id) {
                t.push(i);
            }
        });
        this.state.data.record.items = t;
        this.setState({ data: this.state.data });
    }
    setItemValue(f, e, id) {
        this.state.data.record.items.forEach(i => {
            if (i.id === id) {
                if (f === 'movementId') {
                    i[f] = e.value;
                    i['movementName'] = e.label;
                }
                else {
                    i[f] = e;
                }
            }
        });
    }
    renderItems() {
        return <table className="table table-bordered acc_grid_row">
            <thead>
                <tr className="active">
                    <td>برنامه</td>
                    <td style={{ "width": "100px" }}>تعداد ست</td>
                    <td style={{ "width": "100px" }}>دفعات هر ست</td>
                    <td style={{ "width": "35px" }}></td>
                </tr>
            </thead>
            <tbody>
                {this.state.data.record.items.map((item, index) =>
                    <tr key={item.id}>
                        <td>
                            <SelectAsync
                                defaultValue={
                                    item.movementId !== null
                                        ? [
                                            {
                                                value: item.movementId,
                                                label: item.movementName,
                                            },
                                        ]
                                        : null
                                }
                                isMulti={false}
                                placeholder="انتخاب"
                                components={{
                                    //DropdownIndicator: () => null,
                                    IndicatorSeparator: () => null,
                                }}
                                noOptionsMessage={({ inputValue }) =>
                                    inputValue ? "نتیجه‌ای یافت نشد" : null
                                }
                                defaultOptions={[]}
                                loadOptions={(inputValue, callback) => this.loadMovementsOptions(inputValue, callback)}
                                onChange={(e) =>
                                    this.setItemValue('movementId', e, item.id)
                                }
                            />
                        </td>
                        <td><NumberFormat value={item.count} onChange={e => this.setItemValue('count', parseInt(e.target.value.replace(/,/g, '')), item.id)} thousandSeparator={true} prefix={''} className='form-control text-center ltr' /></td>
                        <td><NumberFormat value={item.count2} onChange={e => this.setItemValue('count2', parseInt(e.target.value.replace(/,/g, '')), item.id)} thousandSeparator={true} prefix={''} className='form-control text-center ltr' /></td>
                        <td>
                            <span title="حذف سطر" onClick={e => this.removeRow(item.id)} className="fa fa-trash fa-fw close-grid-row"></span>
                        </td>
                    </tr>
                )}
            </tbody>
        </table>
    }
    renderForm() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog ui-draggable" style={{ "width": "96%" }}>
                <div className="modal-content">
                    <div className="modal-body" style={{ "padding": "0" }}>
                        <div className="modal-header modal-header-info">
                            <button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                            <h4 className="modal-title">
                                {this.state.data.record.id !== this.defaultGuid() ? "ویرایش اطلاعات شخص" : "افزودن شخص جدید"}
                            </h4>
                        </div>
                        {this.renderBody()}
                    </div>
                </div>
            </div>
        </div>
    }
    renderBody() {
        return [
            <div className="modal-body">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-3">
                            <div className="form-group">
                                <label className="form-label">شخص</label>
                                <SelectAsync
                                    isClearable={true}
                                    defaultValue={this.state.data.record.personId == null ? null : [{ value: this.state.data.record.personId, label: this.state.data.record.personName }]}
                                    isMulti={false}
                                    placeholder="شخص"
                                    defaultOptions
                                    loadOptions={(inputValue, callback) => this.loadPersonsOptions(inputValue, callback)}
                                    onChange={e => {
                                        if (e == null) {
                                            this.state.data.record.personId = null;
                                            this.state.data.record.personName = '';
                                        }
                                        else {
                                            this.state.data.record.personId = e.value;
                                            this.state.data.record.personName = e.label;
                                        }
                                        this.setState({ data: this.state.data });
                                    }}
                                />
                            </div>
                        </div>
                        <div className="col-lg-3">
                            <div className="form-group">
                                <label className="form-label">عنوان</label>
                                <div className="form-control-wrap">
                                    <input className="form-control" type="text" defaultValue={this.state.data.record.title} onChange={e => this.state.data.record.title = e.target.value} />
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-1">
                            <div className="form-group">
                                <label className="form-label">کد</label>
                                <div className="form-control-wrap">
                                    <input autocomplete="off" defaultValue={this.state.data.record.code} onChange={e => this.state.data.record.code = parseInt(e.target.value)} onkeypress="return isCharacterKey(event)" type="text" className="form-control input-sm" maxlength="100" />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-1">
                            <div className="form-group">
                                <label className="form-label">زمان (روز)</label>
                                <input autoComplete="off" defaultValue={this.state.data.record.duration} onChange={e => this.state.data.record.duration = parseInt(e.target.value)} type="text" className="form-input" maxLength="100" />
                            </div>
                        </div>
                        <div className="col-lg-1">
                            <div className="form-group">
                                <label className="form-label">تعداد تکرار</label>
                                <input autoComplete="off" defaultValue={this.state.data.record.repeat} onChange={e => this.state.data.record.repeat = parseInt(e.target.value)} type="text" className="form-input" maxLength="100" />
                            </div>
                        </div>
                        <div className="col-lg-1">
                            <div className="form-group">
                                <label className="form-label">تاریخ شروع</label>
                                <DatePicker
                                    inputReadOnly={false}
                                    className="form-input"
                                    placeholder={'تاریخ شروع'}
                                    isGregorian={false}
                                    showTodayButton={true}
                                    timePicker={false}
                                    onChange={(e) => this.state.data.record.startDate = e}
                                    value={this.getFormatedDateForDatePicker(this.state.data.record.startDate)}
                                />
                            </div>
                        </div>
                        <div className="col-sm-3">
                            <div className="form-group">
                                <label className="form-label">نوع</label>
                                <div className="form-control-wrap">
                                <SelectAsync
                                    isClearable={true}
                                    defaultValue={this.state.data.record.curriculumTypeId == null ? null : [{ value: this.state.data.record.curriculumTypeId, label: this.state.data.record.curriculumTypeTitle }]}
                                    isMulti={false}
                                    placeholder="نوع برنامه"
                                    defaultOptions
                                    loadOptions={(inputValue, callback) => this.loadCurriculumTypesOptions(inputValue, callback)}
                                    onChange={e => {
                                        if (e == null) {
                                            this.state.data.record.curriculumTypeId = null;
                                            this.state.data.record.curriculumTypeTitle = '';
                                        }
                                        else {
                                            this.state.data.record.curriculumTypeId = e.value;
                                            this.state.data.record.curriculumTypeTitle = e.label;
                                        }
                                        this.setState({ data: this.state.data });
                                    }}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-3">
                            <div className="form-group">
                                <label className="form-label">سطح</label>
                                <div className="form-control-wrap">
                                <SelectAsync
                                    isClearable={true}
                                    defaultValue={this.state.data.record.curriculumLevelId == null ? null : [{ value: this.state.data.record.curriculumLevelId, label: this.state.data.record.curriculumLevelTitle }]}
                                    isMulti={false}
                                    placeholder="سطح برنامه"
                                    defaultOptions
                                        loadOptions={(inputValue, callback) => this.loadCurriculumLevelsOptions(inputValue, callback)}
                                    onChange={e => {
                                        if (e == null) {
                                            this.state.data.record.curriculumLevelId = null;
                                            this.state.data.record.curriculumLevelTitle = '';
                                        }
                                        else {
                                            this.state.data.record.curriculumLevelId = e.value;
                                            this.state.data.record.curriculumLevelTitle = e.label;
                                        }
                                        this.setState({ data: this.state.data });
                                    }}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3">
                            <div className="form-group">
                                <label className="form-label">عکس بدن</label>
                                <input type="file" onChange={(e) => { this.setProfilePic(e.target.files[0]) }} />
                            </div>
                        </div>
                        {!this.isBlank(this.state.data.record.bodyImage) && <div className="col-lg-2">
                            <div className="form-group">
                                <label className="form-label">عکس فعلی بدن</label>
                                <a href={this.state.data.record.bodyImagePath} target="_blank"><img src={this.state.data.record.bodyImagePath} style={{ width: "100px", "height": "100px" }} /></a>
                            </div>
                        </div>} 
                        <div className="col-sm-12">
                            <div className="form-group">
                                <label className="form-label">توضیحات</label>
                                <div className="form-control-wrap">
                                    <textarea autocomplete="off" defaultValue={this.state.data.record.description} onChange={e => this.state.data.record.description = e.target.value} type="text" className="form-control input-sm" ></textarea>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-12">
                            <div className="form-group">
                                <label className="form-label"><input type="checkbox" defaultChecked={this.state.data.record.isActive} onChange={e => this.state.data.record.isActive = e.target.checked} /> فعال است</label>
                            </div>
                        </div>
                    </div>
                    {this.renderItems()}
                    <div className="row mt-4">
                        <div className="col-sm-12">
                            <div className="btn-group" role="group">
                                <button type="button" className="btn btn-primary btn-sm hand" onClick={e => this.addNewRow()}>
                                    افزودن حرکت جدید
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>,
            <div className="modal-footer">
                <button type="button" className="btn btn-dim btn-outline-light" onClick={e => this.closeMe()}><span className="shortcut">Esc - </span>انصراف</button>
                <button type="submit" onClick={e => this.save(e)} className="btn btn-success">
                    <span className="shortcut">F4 - </span> ذخیره
                </button>
            </div>
        ];
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.state.inline ? this.renderBody() : this.renderForm()
            ];

        return contents;
    }
}